import * as React from 'react';
import HistoricalFinancialsTable from './HistoricalFinancialsTable';
import HistoricalBalanceSheetModal from './HistoricalBalanceSheetModal';

function HistoricalBalanceSheet({data} :any) {

  function balanceSheetMetrics() : Array<any> {
    return [
      {
        displayName: 'Current Assets',
        columnName: 'current_assets',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Non Current Assets',
        columnName: 'non_current_assets',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Total Assets',
        columnName: 'assets',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Current Liabilities',
        columnName: 'current_liabilities',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Non Current Liabilities',
        columnName: 'non_current_liabilities',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Total Liabilities',
        columnName: 'liabilities',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Retained Earnings',
        columnName: 'retained_earnings',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Equity',
        columnName: 'equity',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Book Value Per Share ($)',
        columnName: 'book_value_per_share',
        className: '',
        useHumanValue: false
      },
      {
        displayName: 'ROA',
        columnName: 'roa',
        className: '',
        useHumanValue: false
      },
      {
        displayName: 'Long Term Debt',
        columnName: 'long_term_debt',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Debt/Equity Ratio',
        columnName: 'liabilities_to_equity_ratio',
        className: 'liabilities_to_equity_ratio_color',
        useHumanValue: false
      },
      {
        displayName: 'Debt payoff',
        columnName: 'debt_to_fcf_human_value',
        className: 'debt_to_fcf_color',
        useHumanValue: false
      },
      {
        displayName: 'ROE',
        columnName: 'roe',
        className: 'roe_color',
        useHumanValue: false
      },
      {
        displayName: 'ROIC',
        columnName: 'roic',
        className: 'roic_color',
        useHumanValue: false
      },
      {
        displayName: 'Current Ratio',
        columnName: 'current_ratio',
        className: 'current_ratio_color',
        useHumanValue: false
      },
    ]
  }

  return (
    <div className="col-lg-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Historical Balance Sheet Financials (Profitability & Liquidity)</h4>
          <p className="card-description">
            <HistoricalBalanceSheetModal data={data} />
          </p>
          <div className="table-responsive">
            <HistoricalFinancialsTable
              financialReport={data.financial_report}
              metricsDictionary={balanceSheetMetrics()}
              numberOfYears={data.financial_report.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoricalBalanceSheet;
